import app from '../app.first';
import 'foundation-datepicker';

app.WorkExperienceInput = class extends app.Component {
	onReady() {
		this.$el.find('.f-date-picker').prop('autocomplete', 'off').fdatepicker({ format: 'yyyy-mm-dd' });

		this.$el.find('.current-job').on('change', e => {
			const $inputs = this.$el.find('[data-disable-if-current]');

			if (e.target.checked)
				$inputs.attr('disabled', true).closest('.input').hide()
					.find('input').prop('disabled', true);
			else
				$inputs.attr('disabled', false).closest('.input').show()
					.find('input').prop('disabled', false);
		}).trigger('change');

		this.$el.find('[data-role-id]').on('change', e => {
			const $roleText = this.$el.find('[data-role-text]');
			if ($(e.target).find('option:selected').text() == 'Other') {
				$roleText.attr('disabled', false).parents('.input').show();
			} else {
				$roleText.attr('disabled', true).parents('.input').hide();
			}
		}).trigger('change');

		let $reasonForLivingDropdowns = $("select.reason_for_living");
		let $otherReasonInputs = $("div.other-reason-input");

		$.each($reasonForLivingDropdowns, el => {
			console.log($reasonForLivingDropdowns)
			let $dropdown = $($reasonForLivingDropdowns);
			$dropdown.select2({
				width: '100%',
				closeOnSelect: !el.multiple,
				placeholder: $dropdown.data('placeholder'),
				tags: Boolean($dropdown.data('tags')),
				limit: 1000
			})
			.on('select2:select', function (e) {
				const $inputs = $($otherReasonInputs[el]);
				if (e.params.data.id === 'other') {
					$inputs.removeClass('hide')
				} else {
					$inputs.addClass('hide')
				}
			})

			$dropdown.trigger('change.select2')
		});

		if ($(".redactor").length) {
			$R('.redactor');
		}
	}
}